(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const closeButton = document.querySelector('.announcement-bar__close');
    const announcementBar = document.querySelector('.announcement-bar');
    
    if (closeButton && announcementBar) {
      closeButton.addEventListener('click', function() {
        announcementBar.style.display = 'none';
        // Store in session so it stays hidden during the session
        sessionStorage.setItem('announcementBarClosed', 'true');
      });

      // Check if user closed it in this session
      if (sessionStorage.getItem('announcementBarClosed') === 'true') {
        announcementBar.style.display = 'none';
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const quantityBtns = document.querySelectorAll('.quantity-btn');
    const cartForm = document.querySelector('.cart-form');
    
    quantityBtns.forEach(btn => {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        const input = this.parentElement.querySelector('.quantity-input');
        const currentValue = parseInt(input.value) || 0;
        const action = this.dataset.action;
        
        if (action === 'increase') {
          input.value = currentValue + 1;
        } else if (action === 'decrease' && currentValue > 0) {
          input.value = currentValue - 1;
          
          // Auto-submit form when quantity reaches 0 to remove item
          if (input.value === '0' && cartForm) {
            cartForm.submit();
          }
        }
      });
    });
    
    // Also handle manual input changes
    document.querySelectorAll('.quantity-input').forEach(input => {
      input.addEventListener('change', function() {
        if (this.value === '0' && cartForm) {
          cartForm.submit();
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const hamburger = document.getElementById('hamburger-btn');
    const menu = document.getElementById('mobile-menu');
    const closeBtn = document.getElementById('close-menu');
    const overlay = document.getElementById('menu-overlay');

    function toggleMenu() {
      hamburger.classList.toggle('active');
      menu.classList.toggle('active');
      overlay.classList.toggle('active');
      document.body.style.overflow = menu.classList.contains('active') ? 'hidden' : '';
    }

    hamburger.addEventListener('click', toggleMenu);
    closeBtn.addEventListener('click', toggleMenu);
    overlay.addEventListener('click', toggleMenu);

    // Close menu when clicking a link
    menu.querySelectorAll('a').forEach(link => {
      link.addEventListener('click', function() {
        if (window.innerWidth <= 768) {
          toggleMenu();
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const mainImage = document.getElementById('main-product-image');
    const thumbnails = document.querySelectorAll('.product-page__thumbnail');
    const lightbox = document.getElementById('product-lightbox');
    const lightboxImage = lightbox ? lightbox.querySelector('.product-lightbox__image') : null;
    const zoomButton = document.querySelector('.product-page__zoom-button');
    const closeButton = lightbox ? lightbox.querySelector('.product-lightbox__close') : null;

    console.log('Product gallery initialized:', {
      mainImage: mainImage,
      thumbnailCount: thumbnails.length
    });

    // Thumbnail click handler
    thumbnails.forEach((thumb, index) => {
      thumb.addEventListener('click', function(e) {
        e.preventDefault();
        console.log('Thumbnail clicked:', index, this.dataset.image);
        
        thumbnails.forEach(t => t.classList.remove('active'));
        this.classList.add('active');
        
        const newImageSrc = this.dataset.image;
        if (mainImage && newImageSrc) {
          // Update both src and srcset to override Shopify's responsive images
          mainImage.src = newImageSrc;
          mainImage.srcset = newImageSrc;
          mainImage.setAttribute('src', newImageSrc);
          mainImage.setAttribute('srcset', newImageSrc);
          console.log('Main image updated to:', newImageSrc);
        }
      });
    });

    // Open lightbox
    function openLightbox() {
      if (lightbox && mainImage && lightboxImage) {
        lightboxImage.src = mainImage.src;
        lightbox.classList.add('active');
        document.body.style.overflow = 'hidden';
      }
    }

    // Close lightbox
    function closeLightbox() {
      if (lightbox) {
        lightbox.classList.remove('active');
        document.body.style.overflow = '';
      }
    }

    if (mainImage) {
      mainImage.addEventListener('click', openLightbox);
    }

    if (zoomButton) {
      zoomButton.addEventListener('click', function(e) {
        e.stopPropagation();
        openLightbox();
      });
    }

    if (closeButton) {
      closeButton.addEventListener('click', closeLightbox);
    }

    if (lightbox) {
      lightbox.addEventListener('click', function(e) {
        if (e.target === lightbox) {
          closeLightbox();
        }
      });
    }

    // ESC key to close
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        closeLightbox();
      }
    });

    // Variant selection logic
    const variantRadios = document.querySelectorAll('.product-page__option-values input[type="radio"]');
    const variantSelect = document.querySelector('.product-page__variant-select');
    
    if (variantRadios.length > 0 && variantSelect) {
      // Function to find matching variant based on selected options
      function updateVariantSelection() {
        const selectedOptions = {};
        
        // Get all selected option values
        document.querySelectorAll('.product-page__option').forEach(optionDiv => {
          const optionName = optionDiv.querySelector('.product-page__option-label').textContent.trim();
          const selectedRadio = optionDiv.querySelector('input[type="radio"]:checked');
          if (selectedRadio) {
            selectedOptions[optionName] = selectedRadio.value;
          }
        });
        
        // Find matching variant in the select options
        for (let option of variantSelect.options) {
          const variantTitle = option.textContent.trim();
          const allOptionsMatch = Object.values(selectedOptions).every(value => 
            variantTitle.includes(value)
          );
          
          if (allOptionsMatch) {
            variantSelect.value = option.value;
            console.log('Variant selected:', option.value, variantTitle);
            break;
          }
        }
      }
      
      // Update variant when any option changes
      variantRadios.forEach(radio => {
        radio.addEventListener('change', updateVariantSelection);
      });
      
      // Initial selection
      updateVariantSelection();
    }
  });

  } catch(e) { console.error(e); }
})();
})();
